(function () {
  if (customElements.get('healr-tabs')) return;

  class HealrTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-healr-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-healr-panel]'));
      this.media = Array.from(this.querySelectorAll('[data-healr-media]'));
      if (!this.tabs.length) return;

      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = (parseFloat(this.dataset.autoplayInterval) || 6) * 1000;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.healrTab, true));
        tab.addEventListener('keydown', (e) => this.onKey(e));
      });

      if (this.autoplay) {
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.resume());
      }

      const initial = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true');
      this.activate(initial ? initial.dataset.healrTab : this.tabs[0].dataset.healrTab);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }

    activate(index, fromClick) {
      this.current = index;
      this.tabs.forEach((tab) => {
        const on = tab.dataset.healrTab === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach((p) => p.toggleAttribute('hidden', p.dataset.healrPanel !== index));
      this.media.forEach((m) => m.classList.toggle('is-active', m.dataset.healrMedia === index));

      if (this.autoplay) this.schedule();
    }

    schedule() {
      clearTimeout(this.timer);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const active = this.tabs.find((t) => t.dataset.healrTab === this.current);
      const ring = active && active.querySelector('[data-healr-ring]');
      if (ring) {
        ring.classList.remove('is-running');
        void ring.offsetWidth; // restart animation
        ring.classList.add('is-running');
      }
      this.timer = setTimeout(() => this.next(), this.interval);
    }

    next() {
      const i = this.tabs.findIndex((t) => t.dataset.healrTab === this.current);
      const nextTab = this.tabs[(i + 1) % this.tabs.length];
      this.activate(nextTab.dataset.healrTab);
    }

    pause() {
      clearTimeout(this.timer);
      const active = this.tabs.find((t) => t.dataset.healrTab === this.current);
      const ring = active && active.querySelector('[data-healr-ring]');
      if (ring) ring.style.animationPlayState = 'paused';
    }

    resume() {
      const active = this.tabs.find((t) => t.dataset.healrTab === this.current);
      const ring = active && active.querySelector('[data-healr-ring]');
      if (ring) ring.style.animationPlayState = 'running';
      if (this.autoplay) this.schedule();
    }

    onKey(e) {
      const i = this.tabs.findIndex((t) => t === document.activeElement);
      if (i < 0) return;
      let next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = this.tabs[(i + 1) % this.tabs.length];
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = this.tabs[(i - 1 + this.tabs.length) % this.tabs.length];
      if (next) {
        e.preventDefault();
        next.focus();
        this.activate(next.dataset.healrTab);
      }
    }
  }

  customElements.define('healr-tabs', HealrTabs);
})();
